import React, { Component } from "react";
import { dispatch } from "@rematch/core";
import {
  Dropdown,
  Checkbox,
  Radio,
  Button,
  Input,
  TextArea,
  Form,
  Message,
} from "semantic-ui-react";
import { toastr } from "react-redux-toastr";

class DynamicForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isEmailValid: true,
      formData: {},
      formErrors:{},
      isSubmitting: false,
    };
  }

  handleChange = (field, value, event) => {
    this.setState((prevState) => {
      const updatedFormData = { ...prevState.formData };
      const updatedFormErrors = {...prevState.formErrors};
      if (field.type === "checkbox") {
        const selectedValues = updatedFormData[field.name] || [];
        updatedFormData[field.name] = !(selectedValues || []).includes(value)
          ? [...selectedValues, value]
          : selectedValues.filter((item) => item !== value);

      } else {
        updatedFormData[field.name] = value;
      }
      let updatedState = {...prevState, formData: updatedFormData };
      if (field.inputType === "email") {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        updatedState.isEmailValid = regex.test(value);
      }
      if (field.isRequired) {
        if (!updatedFormData[field.name] || (Array.isArray(updatedFormData[field.name]) && updatedFormData[field.name].length === 0)) {
            updatedFormErrors[field.name] = `${field.title} is required`;
        } else {
            delete updatedFormErrors[field.name];
        }
      }
      updatedState.formErrors = updatedFormErrors;
      return updatedState;
    });
  };

  handleSubmit = async () => {
    this.setState({ isSubmitting: true });
    const { fieldsData, selectedActivityData } = this.props;
    const { formData } = this.state;
    if (!fieldsData) return;
    let payload = {};
    let errors = {};
    fieldsData.forEach(field => {
      if (field.isRequired) {
          const value = formData[field.name];
          if (value === undefined || value === null || value === "" || 
              (Array.isArray(value) && value.length === 0)) {
              errors[field.name] = `${field.title} is required`;
          }
      }
    });
    this.setState({ formErrors: errors });
    if(Object.keys(errors).length > 0){
      this.setState({ isSubmitting: false });
      return;
    }
    fieldsData.forEach((field) => {
      if (field.type === "checkbox") {
        payload[field.name] = formData[field.name] || [];
      } else {
        payload[field.name] = formData[field.name];
      }
    });

    const updateElement = {
      $set: {
        "metaData.formElement": payload,
        runStatus: 2,
      },
    };

    const data = {
      id: selectedActivityData._id,
      updateElement: updateElement,
      initiativeId:selectedActivityData.initiativeId._id
    };
    try {
      await dispatch.initiatives.updateInitiativeChecklist(data);
      toastr.success("Activity Completed", "Activity Completed successfully");
    } catch (error) {
      console.error("Error updating activity:", error);
    }
    this.setState({ isSubmitting: false });
  };

  handleSaveAsDraft = async () => {
    const { fieldsData, selectedActivityData } = this.props;
    const { formData } = this.state;
    if (!fieldsData) return;
    let payload = {};
    fieldsData.forEach((field) => {
      if (field.type === "checkbox") {
        payload[field.name] = formData[field.name] || [];
      } else {
        payload[field.name] = formData[field.name];
      }
    });

    const updateElement = {
      $set: {
        "metaData.formElement": payload,
      },
    };

    const data = {
      id: selectedActivityData._id,
      updateElement: updateElement,
      initiativeId:selectedActivityData.initiativeId._id
    };
    try {
      await dispatch.initiatives.updateInitiativeChecklist(data);
      toastr.success("Activity Saved", "Activity Updated successfully");
    } catch (error) {
      console.error("Error updating activity:", error);
    }
  };

  componentDidMount() {
    const { selectedActivityData } = this.props;
    if (selectedActivityData && 
        selectedActivityData.metaData && 
        selectedActivityData.metaData.formElement) {
      this.setState({ formData: selectedActivityData.metaData.formElement });
    }
  }

  componentDidUpdate(prevProps) {
    const { selectedActivityData } = this.props;
    if (selectedActivityData && 
        selectedActivityData.metaData && 
        selectedActivityData.metaData.formElement &&
        prevProps.selectedActivityData && 
        prevProps.selectedActivityData.metaData && 
        prevProps.selectedActivityData.metaData.formElement !== selectedActivityData.metaData.formElement
    ) {
      this.setState({ formData: selectedActivityData.metaData.formElement });
    }
  }


  render() {
    const { fieldsData, selectedActivityData } = this.props;
    const { formData, isSubmitting } = this.state;
    const { isEmailValid } = this.state;
    return (
      <Form>
        <Message info><span style={{ color: "red"}}>*</span> Required fields</Message>
        {fieldsData.map((field) => (
          <Form.Field className="fieldLabel" key={field.id} required={field.isRequired} style={{backgroundColor: "white", padding: "10px", borderRadius: "5px", marginBottom: "10px"}} >
            <label className="bold-label">
              {field.title}
            </label> 
            {field.type === "dropdown" && (
              <div>
              <Dropdown
                fluid
                selection
                options={field.choices.map((choice) => ({
                  key: choice,
                  text: choice,
                  value: choice,
                }))}
                placeholder={field.placeholder}
                value={formData[field.name] || ""}
                onChange={(e, { value }) => this.handleChange(field, value, e)}
                disabled={selectedActivityData.runStatus !== 1 || selectedActivityData.onHoldFlag}
              />
              {field.isRequired && this.state.formErrors[field.name] && (
                <span style={{ color: "red", fontSize: "10px" }}>
                  {field.title} is Required
                </span>
              )}
              </div>
            )}
            {field.type === "comment" && (
              <div>
              <TextArea
                value={formData[field.name] || ""}
                onChange={(e) => this.handleChange(field, e.target.value, e)}
                disabled={selectedActivityData.runStatus !== 1 || selectedActivityData.onHoldFlag}
              />
              {field.isRequired && this.state.formErrors[field.name] && (
                <span style={{ color: "red", fontSize: "10px" }}>
                  {field.title} is Required
                </span>
              )}
              </div>
            )}
            {field.type === "checkbox" && (
              <div>
                {field.choices.map((choice) => (
                  <div>
                  <input
                  type="checkbox"
                  style={{marginTop: "2px"}}
                  id={choice}
                  checked={(formData[field.name] || []).includes(choice)}
                  onChange={(e) => this.handleChange(field, choice, e)}
                  disabled={selectedActivityData.runStatus !== 1 || selectedActivityData.onHoldFlag}
                />
                <span
                  htmlFor={choice}
                  style={{ color: "black", marginLeft: "10px", fontFamily:"montserrat-semibold" }} 
                >
                  {choice}
                </span></div>
                ))}
                {field.isRequired && this.state.formErrors[field.name] && (
                  <span style={{ color: "red", fontSize: "10px" }}>
                  {field.title} is Required
                </span>
                )}
              </div>
            )}
            {field.type === "radiogroup" && ( 
              <div>
                { field.choices.map((choice) => (
                  <Radio
                    key={choice}
                    label={choice}
                    name={field.name}
                    style={{ display: "block", marginTop: "10px" }}
                    value={choice}
                    checked={formData[field.name] === choice}
                    onChange={(e) => this.handleChange(field, choice, e)}
                    disabled={selectedActivityData.runStatus !== 1 || selectedActivityData.onHoldFlag}
                  />
                ))}
                {field.isRequired && this.state.formErrors[field.name] && (
                   <span style={{ color: "red", fontSize: "10px" }}>
                  {field.title} is Required
                </span>
                )}
              </div>
            )}
            {field.inputType === "email" && (
              <div>
              <Input
                type="email"
                value={formData[field.name] || ""}
                onChange={(e) =>
                  this.handleChange(field, e.target.value, e)
                }
                error={!isEmailValid}
                placeholder={field.placeholder}
                disabled={selectedActivityData.runStatus !== 1 || selectedActivityData.onHoldFlag}
              />
               {(this.state.formErrors[field.name] || 
            (field.inputType === "email" && !this.state.isEmailValid)) && (
            <span style={{ color: "red", fontSize: "10px" }}>
              {this.state.formErrors[field.name] || "Invalid email format"}
            </span>
          )}
              </div>
            )}
            {field.inputType === "number" && (
              <div>
              <Input
                type="number"
                value={formData[field.name] || ""}
                placeholder={field.placeholder}
                onChange={(e) => this.handleChange(field, e.target.value, e)}
                disabled={selectedActivityData.runStatus !== 1 || selectedActivityData.onHoldFlag}
              />
              {field.isRequired && this.state.formErrors[field.name] && (
                <span style={{ color: "red", fontSize: "10px" }}>
                  {field.title} is Required
                </span>
              )}</div>
            )}
            {field.inputType === "text" && (
            <div>
              <Input
                type="text"
                value={formData[field.name] || ""}
                placeholder={field.placeholder}
                onChange={(e) => this.handleChange(field, e.target.value, e)}
                disabled={selectedActivityData.runStatus !== 1 || selectedActivityData.onHoldFlag}
              />
              {field.isRequired && this.state.formErrors[field.name] && (
                <span style={{ color: "red", fontSize: "10px" }}>
                  {field.title} is Required
                </span>
              )}
            </div>
          )}
            {/* {!isEmailValid && field.inputType === "email" && (
              <Message negative>Invalid email format</Message>
            )} */}
          </Form.Field>
        ))}
        <div style={{ float: "right", marginBottom:'4px' }}>
          <Button
            primary
            className="button-info"
            onClick={this.handleSubmit}
            disabled={selectedActivityData.runStatus !== 1 || selectedActivityData.onHoldFlag || isSubmitting}
          >
            Complete
          </Button>
          <Button
            className="button-info"
            onClick={this.handleSaveAsDraft}
            disabled={selectedActivityData.runStatus !== 1 || selectedActivityData.onHoldFlag || isSubmitting}
          >
            Save as Draft
          </Button>
        </div>
      </Form>
    );
  }
}

export default DynamicForm;
